export const VERIFICATION_STATUS_VERIFYING = "VERIFICATION_STATUS_VERIFYING";
export const VERIFICATION_STATUS_VERIFIED_SUCCESSFULLY =
  "VERIFICATION_STATUS_VERIFIED_SUCCESSFULLY";
export const VERIFICATION_STATUS_NOT_VERIFIED =
  "VERIFICATION_STATUS_NOT_VERIFIED";
export const VERIFICATION_STATUS_INVALID_HASH =
  "VERIFICATION_STATUS_INVALID_HASH";
